var _path, _path2, _circle, _path3, _path4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLandPortugal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 36 36",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.999,18C2.999,11.555 7.074,6.053 12.785,3.933L12.918,3.884L15.006,17.747L12.913,32.114L12.785,32.067C7.074,29.947 2.999,24.445 2.999,18Z",
    fill: "#6da544"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.819,33C16.099,32.979 14.448,32.669 12.913,32.114L12.785,32.067L12.785,3.933L12.918,3.884C14.505,3.311 16.217,3 18,3C26.218,3 32.902,9.624 33,17.819L33,18.181C32.903,26.316 26.316,32.903 18.181,33L17.819,33Z",
    fill: "#d80027"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.785,
    cy: 17.999,
    r: 5.215,
    fill: "#ffda44"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.849,15.392L9.849,18.644C9.858,20.249 11.176,21.567 12.781,21.577C14.387,21.567 15.705,20.249 15.714,18.644L15.714,15.387L9.855,15.387L9.849,15.392Z",
    fill: "#d80027"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.785,19.628C12.246,19.628 11.806,19.189 11.806,18.65L11.806,17.355L13.763,17.355L13.763,18.644C13.763,19.183 13.324,19.622 12.785,19.622L12.785,19.628Z",
    fill: "#eee"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLandPortugal);
export default __webpack_public_path__ + "static/media/land_portugal.6c314dcb4b1c1d115d75a62484457157.svg";
export { ForwardRef as ReactComponent };